import { BuildingType } from '../../../generated/graphql'

export enum BaseDataType { // TODO: move to api?
  MeasuredData = 'MeasuredData',
  BuildingTemplate = 'BuildingTemplate',
  NoBaseData = 'NoBaseData',
}

export type FormValues = {
  name: string
  area: string
  type: BuildingType
  baseDataType: BaseDataType
  demandHourSeriesIds: string[]
}
